module.exports = __webpack_public_path__ + "assets/icons/magnifying-glass.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/magnifying-glass.png
// module id = ./src/styles/icons/emojies/magnifying-glass.png
// module chunks = 0